/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Best_DescriptionInputs */

const et_plan_best_description = /** @type {(inputs: Plan_Best_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google esi 3-me esimese 90 päevaga. Garanteeritud.`)
};

const en_plan_best_description = /** @type {(inputs: Plan_Best_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google top 3 within 90 days. Guaranteed.`)
};

/**
* | output |
* | --- |
* | "Google top 3 within 90 days. Guaranteed." |
*
* @param {Plan_Best_DescriptionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_best_description = /** @type {((inputs?: Plan_Best_DescriptionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Best_DescriptionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_best_description(inputs)
	return en_plan_best_description(inputs)
});